// extracted by mini-css-extract-plugin
export default {"whyUs":"whyUs_whyUs__I0vYs","sectionBG":"whyUs_sectionBG__-gsX5","more-btn":"whyUs_more-btn__fuLNa","icon-box":"whyUs_icon-box__cTqxB"};